import type { Program, Word } from "../types";

type PlayWord = (word: Word, phrase: boolean, extra?: Partial<Program>) => unknown;

/** Plays the word when a card is revealed, then its example once the word clip finishes. */
export function createAnswerAudio(playWord: PlayWord) {
  let pending: { word: Word; token: string } | null = null;
  let serial = 0;
  return {
    reveal(word: Word, enabled: boolean) {
      pending = null;
      if (!enabled) return;
      const token = `answer-${++serial}`;
      pending = { word, token };
      void playWord(word, false, { answerAudioToken: token });
    },
    complete(program: Program) {
      if (!pending || program.answerAudioToken !== pending.token) return;
      const { word, token } = pending;
      pending = null;
      void playWord(word, true, { answerAudioToken: token + "-phrase" });
    },
    cancel() { pending = null; },
  };
}
